import {
	type DtmOrthoFilePair,
	toStorageNodeRef,
} from "@/components/AddData/dtm-ortho/dtmOrtho.types";
import type {
	AssetLinkExtensions,
	DashboardDtmOrthoDataset,
	DtmOrthoDatasetListResponse,
	SelectableDtmOrthoDataset,
} from "@/components/Project/dashboardImport.types";

export interface DtmOrthoDatasetListConversion {
	readonly datasets: readonly DashboardDtmOrthoDataset[];
	readonly extensions: AssetLinkExtensions;
}

/**
 * GET /v2/api/:siteId/dtm-ortho/dashboard-datasets の応答を画面の形に写す。
 * 応答の bucket_id を resolved / unresolved の各要素へ写し、kind はそのまま保つ。
 * extensions は変換せずそのまま返す
 */
export const convertDtmOrthoDatasetResponse = (
	response: DtmOrthoDatasetListResponse,
): DtmOrthoDatasetListConversion => {
	const bucketId = response.bucket_id;
	const datasets = response.datasets.map(
		(dataset): DashboardDtmOrthoDataset =>
			dataset.kind === "rejected" ? dataset : { ...dataset, bucketId },
	);
	return { datasets, extensions: response.extensions };
};

/**
 * 選択されたデータセットを種別選択ダイアログに渡す組にする（origin: "storage"）。
 * resolved は [オルソ, DTM] の順（ダイアログの既定 = 1 件目が画像 が自動判別の結果になる。GI-38）、
 * unresolved は名前順のまま（1 件目が画像になるのはダイアログの既定値）。name は表示名で org_name は使わない（GI-10）
 */
export const convertDatasetToFilePair = (
	dataset: SelectableDtmOrthoDataset,
): DtmOrthoFilePair => {
	const [first, second] =
		dataset.kind === "resolved"
			? [dataset.image, dataset.terrain]
			: dataset.files;
	return {
		origin: "storage",
		files: [
			toStorageNodeRef(dataset.bucketId, first),
			toStorageNodeRef(dataset.bucketId, second),
		],
	};
};
